import { __decorate, __metadata } from "tslib";
import { SerializableObject } from '../../decorators';
import { Orientation } from '../../position';
import { SensorObject } from '../SensorObject';
/**
 * The relative orientation sensor describes the device's physical orientation without regard to the Earth's reference coordinate system.
 * @category data
 */
let RelativeOrientationSensor = class RelativeOrientationSensor extends SensorObject {
  constructor(uid, value, frequency, displayName) {
    super(uid, value !== null && value !== void 0 ? value : new Orientation(), frequency, displayName);
  }
};
RelativeOrientationSensor = __decorate([SerializableObject(), __metadata("design:paramtypes", [String, Orientation, Number, String])], RelativeOrientationSensor);
export { RelativeOrientationSensor };